import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import { useState } from 'react'
import { v4 } from 'uuid'
import ExpandDetail from './ExpandDetail'

const HotelAmenityLayout = ({ layout, value, handleDetailPageClose }) => {
  const [isTags, setshowTags] = useState(false)
  const showTags = () => {
    setshowTags(!isTags)
  }
  // dialogues box
  const [open, setOpen] = useState(false)

  const handleExpandPageOpen = () => {
    setOpen(true)
  }

  const handleExpandPageClose = () => {
    setOpen(false)
  }
  //----
  const icon = require('../../../assets/images/tick.svg').default
  let tags = []
  return (
    <div
      style={{
        padding: '16px 20px 24px 20px',
        background: layout.color ? `#${layout.color}` : '',
        // background: '#f000f0',
      }}
    >
      <div
        style={{
          marginTop: '10px',
          marginBottom: '24px',
          textAlign: 'left',
          color: 'var(--gray100)',
          listStyle: 'none',
        }}
      >
        <p className="headline1">{layout.display_name}</p>
      </div>
      {value.map((item) => {
        {
          item.values.map((innerItem) => {
            tags.push(innerItem.value)
          })
        }
      })}
      <Stack
        direction="row"
        // spacing={2}
        sx={{ display: 'flex', flexWrap: 'wrap', marginLeft: '0px' }}
      >
        {tags.map((tag, index) => {
          if (index <= 7) {
            return (
              <Chip
                label={tag}
                key={v4()}
                style={{
                  background: '#E7E9F2',
                  color: 'var(--gray80)',
                  marginRight: '8px',
                  marginBottom: '14px',
                  fontSize: '15px',
                }}
              />
            )
          }
        })}
        {isTags &&
          tags.map((tag, index) => {
            if (index > 7) {
              return (
                <Chip
                  label={tag}
                  key={v4()}
                  style={{
                    background: '#E7E9F2',
                    color: 'var(--gray80)',
                    marginRight: '8px',
                    marginBottom: '14px',
                    fontSize: '15px',
                  }}
                />
              )
            }
          })}

        <span
          className="headline2"
          style={{ color: 'var(--primaryShades20)', cursor: 'pointer' }}
          onClick={() => {
            handleExpandPageOpen()
          }}
        >
          {tags.length > 8 ? '+ ' + (tags.length - 8) + ' more ' : ''}
        </span>
      </Stack>
      {/* <button
        onClick={(e) => {
          e.preventDefault()
          handleExpandPageOpen()
        }}
      >
        open dialog
      </button> */}
      <ExpandDetail
        open={open}
        handleExpandPageClose={handleExpandPageClose}
        handleDetailPageClose={handleDetailPageClose}
        value={value}
        layout={layout}
        contentType={'hotel_amenities'}
      />
    </div>
  )
}

export default HotelAmenityLayout
